<template>
    <v-container fluid pt-5>
        <v-toolbar
                flat
                scroll-off-screen
                app
                color="grey lighten-3"
        >
            <img
                height="40"
                src="@/assets/img/logo.png"
            />
            <v-spacer></v-spacer>
            <h3 class="font-weight-light">Activación de cuenta</h3>
        </v-toolbar>
        <v-layout wrap justify-center align-center>
            <v-flex xs12 md8 lg6>
                <account-activator :code="$route.params.code"></account-activator>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

    import AccountActivator from '@/components/account/AccountActivator'

    export default{
        components: {AccountActivator}

    }
</script>